const IconMore= ({className = ''}) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 15.8 15.8"
    xmlSpace="preserve"
    className={className}
  >
    <g>
      <line
        stroke="#E2E2E2"
        strokeWidth={1.6913}
        strokeLinecap="round"
        strokeMiterlimit={10}
        x1={7.9}
        y1={0.8}
        x2={7.9}
        y2={14.9}
      />
      <line
        stroke="#E2E2E2"
        strokeWidth={1.6913}
        strokeLinecap="round"
        strokeMiterlimit={10}
        x1={14.9}
        y1={7.9}
        x2={0.8}
        y2={7.9}
      />
    </g>
  </svg>
);

export default IconMore;